import { render, staticRenderFns } from "./ProductShippingMethods.vue?vue&type=template&id=74b85d0c&"
import script from "./ProductShippingMethods.vue?vue&type=script&lang=js&"
export * from "./ProductShippingMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports